// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

// OAuth Configuration
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

// Local Storage Keys
// DEPRECATED: Tokens are now stored in httpOnly cookies for security
// These keys are kept for backward compatibility only
export const AUTH_TOKEN_KEY = 'concerto_auth_token';
export const REFRESH_TOKEN_KEY = 'concerto_refresh_token';
// User data is still stored in localStorage for UI purposes
export const USER_KEY = 'concerto_user';

// Routes
export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  SIGNUP: '/signup',
  DASHBOARD: '/dashboard',
  GOOGLE_CALLBACK: '/auth/google/callback',
  MICROSOFT_CALLBACK: '/auth/microsoft/callback',
  SETTINGS: '/settings',
  FOCUS: '/focus',
  TODAY: '/today',
  INBOX: '/inbox',
  EMAIL_THREAD: '/email/:id',
  CALENDAR: '/calendar',
  TASKS: '/tasks',
  TASK_ANALYTICS: '/tasks/analytics',
  CONTACTS: '/contacts',
  CONTACT_DETAIL: '/contacts/:id',
  CONTACTS_HARMONIZE: '/contacts/harmonize',
  CONTACTS_HARMONIZE_CIRCLES: '/contacts/harmonize/circles',
  CONTACTS_HARMONIZE_MERGE: '/contacts/harmonize/merge',
  GOALS: '/goals',
  GOAL_DETAIL: '/goals/:id',
  ENDEAVORS: '/endeavors',
  ENDEAVOR_DETAIL: '/endeavors/:id',
  ENDEAVOR_WORKSPACE: '/endeavors/:id/workspace',
  WEEKLY_REVIEWS: '/weekly-reviews',
  NOTES: '/notes',
  BOOKMARKS: '/bookmarks',
  DOCUMENTS: '/documents',
  AFFINITY_DIAGRAMS: '/affinity-diagrams',
  HEALTH: '/health',
  HEALTH_METRIC_DETAIL: '/health/:id',
  CHAT: '/chat',
  PRIVACY_POLICY: '/privacy',
  TERMS_OF_SERVICE: '/terms',
  WHOOP_CALLBACK: '/integrations/whoop/callback',
} as const;

// API Endpoints
export const API_ENDPOINTS = {
  AUTH: {
    REGISTER: '/api/v1/auth/register',
    LOGIN: '/api/v1/auth/login',
    REFRESH_TOKEN: '/api/v1/auth/refresh-token',
    GOOGLE: '/api/v1/auth/google',
    GOOGLE_CALLBACK: '/api/v1/auth/google/callback',
    LOGOUT: '/api/v1/auth/logout',
    ME: '/api/v1/auth/me',
  },
} as const;

// Common timezones for dropdowns
export const TIMEZONES = [
  'America/Los_Angeles',
  'America/Denver',
  'America/Chicago',
  'America/New_York',
  'America/Phoenix',
  'America/Anchorage',
  'Pacific/Honolulu',
  'UTC',
  'Europe/London',
  'Europe/Paris',
  'Europe/Berlin',
  'Asia/Tokyo',
  'Asia/Shanghai',
  'Asia/Dubai',
  'Australia/Sydney',
] as const;

